import React, { Component } from 'react'
import PropTypes from 'prop-types'
import isEqual from 'lodash/isEqual'
import has from 'lodash/has'
import get from 'lodash/get'

import LogoContainer from './components/LogoContainer'
import Intro from './components/scenes/Intro'
import Showcase from './components/showcase/Showcase'
import RotateNotification from '../shared/components/RotateNotification'
import { initApi, api } from '../../api/integrationAPI'
import { runSequence, stopSequence } from '../../utils/sequence'
import { customCSSObjectToString } from '../../utils/serializerCSS'
import { getImageUrlsFromSettings, preloadImages } from '../../utils/templatesUtils'
import * as scenes from './scenes'
import { appLoaded } from '../shared/analytics'

import './InstantApp.scss'


export default class InstantApp extends Component {

  constructor (props) {
    super(props)
    this.state = {
      scene: scenes.PRELOAD,
      showcaseNum: 0,
      productShown: null,
      isCartOpened: false,
      initialized: false,
      cart: null,
      prevPositionY: null
    }
  }

  componentDidMount () {
    if (!this.props.editMode && !this.props.showcaseMode) {
      // scrollFix() //Turned off because of scroll not working with it on iOS 10.1 Safari TODO: investigate with different browsers
    }

    let iOSinsta = /iPad|iPhone|iPod/ && /Instagram/.test(navigator.userAgent) && !window.MSStream

    if (iOSinsta) {
      // document.getElementsByTagName('html')[0].style.height = 'calc(100% - 64px)'
      // document.getElementsByTagName('html')[0].style.marginTop = '64px'
      document.getElementsByTagName('html')[0].style.height = '100%'
      document.getElementsByTagName('body')[0].style.position = 'absolute'
      document.getElementsByTagName('html')[0].addEventListener('touchmove', e => this.onTouchMove(e))
      document.getElementsByTagName('html')[0].addEventListener('touchstart', e => this.onTouchStart(e))
    }

    this.initIntegration(this.props.appId, this.props.settings.appSettings.integration, this.props.dispatch)

    this.startAnimations()

    if (this.prodMode()) appLoaded()

    preloadImages(getImageUrlsFromSettings(this.props.settings)) // Preload all images from settings
  }

  onTouchStart (e) {
    const touch = e.touches[0]
    this.setState({
      prevPositionY: touch.pageY
    })
  }

  onTouchMove (e) {
    if (!e.target.className.includes('js-scroll')) {
      e.preventDefault()
    } else if (e.target.className.includes('js-scroll-x')) {
      const touch = e.touches[0]
      if (touch.pageY - this.state.prevPositionY < 0) {
        if (touch.pageY - this.state.prevPositionY < -10) {
          e.preventDefault()
        }
      } else {
        if (touch.pageY - this.state.prevPositionY > 10) {
          e.preventDefault()
        }
      }
    }
  }

  startAnimations () {
    if (this.props.editMode) {
      this.updateState({ scene: scenes.INTRO })
      return
    }
    // Start animation sequence
    this.sequenceId = runSequence([
      { fn: () => this.updateState({scene: scenes.INTRO}), delay: 100 },
      { fn: () => this.updateState({scene: scenes.SHOWCASE}), delay: 4000 },
    ])
  }

  componentWillReceiveProps (nextProps) {
    const location = nextProps.location
    if (!location.productShown) location.productShown = null
    // console.log('componentWillReceiveProps', location)
    this.setState({ ...location, isCartOpened: false }) // Exit shopping cart if something's changed in editor
    const newIntegration = nextProps.settings.appSettings.integration
    const oldIntegration = this.props.settings.appSettings.integration
    // const integrationChanged = JSON.stringify(newIntegration) !== JSON.stringify(oldIntegration)
    const integrationChanged = !isEqual(newIntegration, oldIntegration)
    // console.log('integrationChanged', integrationChanged)
    // console.log('simple equal', isEqual(newIntegration, oldIntegration))
    // console.log('old', oldIntegration, 'new', newIntegration, 'changed', integrationChanged)
    // console.log('...', newIntegration === oldIntegration)
    if (integrationChanged) {
      // console.log('componentWillReceiveProps: integration changed')
      this.setInitialized(false, () => {
        this.initIntegration(nextProps.appId, nextProps.settings.appSettings.integration, nextProps.dispatch)
      })
    }
  }

  componentWillUnmount () {
    stopSequence(this.sequenceId)
  }

  onChangeCart = (cart) => {
    // console.log('onChangeCart', cart)
    this.setState({ cart })
  }

  setInitialized = (value, callback = () => null) => {
    // console.log('setInitialized', value, 'api:', api)
    if (!this.state.initialized && value) {
      window.logTiming('setInitialized')
      this.setState({
        cart: api.getCart(),
        initialized: true
      })
      api.setOnChangeCart(this.onChangeCart)
    } else if (!value) {
      if (api) api.setOnChangeCart(null)
      this.setState({
        cart: null,
        initialized: false
      }, callback)
    }
  }

  initIntegration (appId, integration, dispatch) {
    window.logTiming('initApi')
    const { settings, editMode, showcaseMode } = this.props
    if (!editMode || (editMode && showcaseMode)) {
      const productIds = []
      console.log('settings', settings)
      for (const showcase of settings.showcases) {
        const products = get(showcase, 'products', [])
        for (const p of products) {
          if (has(p, 'info.productId')) productIds.push(p.info.productId)
        }
      }
      console.log('productIds', productIds)
      initApi(appId, integration, this.setInitialized, dispatch, productIds)
    } else {
      initApi(appId, integration, this.setInitialized, dispatch)
    }
  }

  prodMode = () => !this.props.editMode && !this.props.showcaseMode

  updateState (patch) {
    const { scene, showcaseNum, productShown } = this.state
    if (patch.scene !== scene || patch.showcaseNum !== showcaseNum || patch.productShown !== productShown) {
      this.setState(patch, () => {
        const loc = {
          scene: this.state.scene,
          showcaseNum: this.state.showcaseNum,
          productShown: this.state.productShown
        }
        if (this.prodMode()) window.ga('send', 'screenview', {screenName: JSON.stringify(loc)})
        this.props.onChange(loc)
      })
    }
  }

  switchCart = () => { // Display/hide shopping cart
    this.setState({ isCartOpened: !this.state.isCartOpened })
  }

  nextScene = () => {
    if (this.state.showcaseNum < this.props.settings.showcases.length) {
      this.updateState({ showcaseNum: this.state.showcaseNum + 1 })
    }
  }

  previousScene = () => {
    if (this.state.showcaseNum > 0) {
      this.updateState({ showcaseNum: this.state.showcaseNum - 1 })
    }
  }

  showProduct = (productKey) => {
    // console.log('showProduct')
    this.updateState({
      productShown: productKey,
      scene: scenes.PRODUCT_INFO
    })
  }

  closeProduct = () => { this.updateState({ productShown: null, scene: scenes.SHOWCASE }) }
  openSettings = () => { this.updateState({ scene: scenes.PRODUCT_DETAILS }) }
  closeSettings = () => { this.updateState({ scene: scenes.PRODUCT_INFO }) }

  handleSlideChange = (slide) => {
    // console.log('handleSlideChange', slide)
    if (this.state.showcaseNum !== slide) {
      this.updateState({ showcaseNum: slide })
    }
  }

  onLoadedStylesheet = () => {
    this.forceUpdate()
  }

  onLinkMounted = (linkRef) => {
    if (linkRef) {
      linkRef.addEventListener('load', this.onLoadedStylesheet)
    }
  }

  getProductInfo = (item) => {
    // console.log('getProductInfo called for item', item)
    const { settings } = this.props
    if (item.info) {
      return api.getProductInfo(item.info, settings.productsDict)
    } else {
      return item
    }
  }

  render () {
    // console.log('InstantApp render', this.props.location)
    const { settings, editMode, showcaseMode } = this.props
    const { scene, showcaseNum } = this.state
    return (
      <div className='in_root'>
        <link
          key={settings.customStylesRawDownloadUrl}
          rel={'stylesheet'}
          ref={this.onLinkMounted}
          href={settings.customStylesRawDownloadUrl}
        />
        <link
          key={settings.customStylesDownloadUrl}
          rel={'stylesheet'}
          ref={this.onLinkMounted}
          href={settings.customStylesDownloadUrl}
        />
        <style id='customStyles'>{customCSSObjectToString(settings.customStyles)}</style>
        {!editMode && !showcaseMode && <RotateNotification />}
        {/* Top-left logo */}
        {scene !== scenes.PRELOAD &&
          <LogoContainer
            settings={settings}
            scene={scene}
            showcaseNum={showcaseNum}
          />
        }
        {/* Intro scene with 3 text lines */}
        <Intro {...settings.intro} isVisible={scene === scenes.INTRO} />
        {/* Swiper scene */}
        <Showcase
          settings={settings}
          cart={this.state.cart}
          showcaseNum={this.state.showcaseNum}
          productShown={this.state.productShown}
          scene={scene}
          isCartOpened={this.state.isCartOpened}
          showProduct={this.showProduct}
          handleSlideChange={this.handleSlideChange}
          previousScene={this.previousScene}
          nextScene={this.nextScene}
          switchCart={this.switchCart}
          closeProduct={this.closeProduct}
          openSettings={this.openSettings}
          closeSettings={this.closeSettings}
          isVisible={scene === scenes.SHOWCASE || scene === scenes.PRODUCT_INFO || scene === scenes.PRODUCT_DETAILS}
          getProductInfo={this.getProductInfo}
          prodMode={this.prodMode()}
        />
      </div>
    )
  }

  static defaultProps = {
    location: {
      sceneNum: scenes.PRELOAD,
      showcaseNum: 0,
      productShown: null
    },
    onChange: () => null
  }

  static propTypes = {
    appId: PropTypes.string,
    settings: PropTypes.shape({
      appSettings: PropTypes.object,
      customStylesDownloadUrl: PropTypes.string,
      intro: PropTypes.object,
      door: PropTypes.object,
      lastScene: PropTypes.object,
      showcases: PropTypes.arrayOf(
        PropTypes.shape({
          image: PropTypes.string,
          products: PropTypes.array
        })
      )
    }).isRequired,
    onChange: PropTypes.func,
    editMode: PropTypes.bool, // Is IA runs in editor
    showcaseMode: PropTypes.bool, // Is IA displayed in editor's dashboard
    location: PropTypes.object, // eslint-disable-line react/no-unused-prop-types
    dispatch: PropTypes.func
  }
}



// WEBPACK FOOTER //
// ./src/templates/insta/InstantApp.js